<template>
    <div class="position-box">
        <div class="header">
			<img class="logo" src="@/assets/new/logo-cme.png" alt="">
		</div>
		<div id="repayment" class="bg">
			<div class="item1-box"></div>
			<div class="order-box">
				<div class="order"><span>{{$t('hkxq.dd')}} </span> {{hkCont[0].no}}</div>
				<div class="ewm-box qrcode"><qriously :value="address" :size="125"/></div>
				<div id="code">{{address}}</div>
				<button class="btn ads-copy" type="button" @click="copy($event)">{{$t('hkxq.fzhkdz')}}</button>
			</div>
			<div class="tips">{{$t('hkxq.hkxq')}}</div>
			<ul class="ul-box">
				<li class="li">
					<div>{{$t('hkxq.zlx')}}</div>
					<div class="t2">{{hkCont[0].interest}}</div>
				</li>
				<li class="li">
					<div>{{$t('hkxq.zhk')}}</div>
					<div class="t2">{{(parseFloat(hkCont[0].amount) + parseFloat(hkCont[0].interest)).toFixed(4)}}</div>
				</li>
				<li class="li">
					<div>{{$t('hkxq.hkjg')}}</div>
					<div class="t2">{{fkjg}}</div>
				</li>
			</ul>
			<div class="tips">{{$t('hkxq.qschkpz')}}</div>
			<div class="upload-box">
				<img class="img js-hkpz" v-if="photo_hkpz" :src="photo_hkpz" alt="" @click="upload">
        <img class="img js-hkpz" v-else src="@/assets/btn-upload.png" alt="" @click="upload">
				<div class="text">{{$t('hkxq.hkpz')}}</div>
			</div>
			<div class="submit-box"><button class="submit btn-bg" type="button" @click="submit">{{$t('sztxmm.t6')}}</button></div>
		</div>
		<div class="mask" v-show="isMask" @click="close"></div>
		<div class="repayment-alert" v-show="isMask">
			<div class="title">{{$t('wydb.yebzqxcz')}}</div>
			<button class="btn" @click="goCz">{{$t('wydb.qcz')}}</button>
		</div>
    <div class="load-box" v-show="isLoad" @click="hideLoad"><img class="load" src="@/assets/new/loading.gif" alt=""></div>
    </div>
</template>

<script>
import lrz from "lrz";
export default {
    name: 'repaymet',
    data () {
        return {
            isLoad: false,
            theme: false,
            isShow: false,
            langText: 'English',
            isMask: false,
            id: '',
            hkCont: [
              {
                no:'',
                interest: 0,
                amount: 0
              }
            ],
            address: '',
            photo_hkpz: '',
            fkjg: ''
        }
    },
    created(){
      this.langText = localStorage.getItem('langText') || 'English';
      this.fkjg = localStorage.getItem('fkjg');
      this.id = this.$route.query.id;
    },
    mounted() {
      this.getMylist();
      this.getChainList()
    },
    methods: {
       back(){
           this.$router.push('/index')
       },
       goDetail(){
           this.$router.push('/helpDetail')
       },
       goCz(){
            this.$router.push('/deposit')
        },
        getMylist(){
            let params = {page: 1};
            this.$ajax.get('/web/lendMylist',{params}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  setTimeout(()=>{
                    this.$router.push('/index');
                  },1000)
                  return false
                }
                this.hkCont = resData.filter((item)=>{
                  if(item.id == this.id){
                    return true
                  }
                })
            }).catch(function(err){
                console.log(err)
            })
       },
        getChainList(){
          let params = {
              currency: 'USDT',
              tag:'lend'
          }
          this.$ajax.get('/web/getChainList',{params}).then((res) => {
              let resData = res.data.data;
              this.address = resData[0].address;
          }).catch(function(err){
              console.log(err)
          })
        },
        getLendBack(){
          let params = {
              id:this.id
          }
          this.$ajax.get('/web/lendlist',{params}).then((res) => {
              let resData = res.data;
              if(resData.code == 5){
                this.isMask = true;
              }else{
                this.isMask = false;
              }
          }).catch(function(err){
              console.log(err)
          })
				},
        submit(){
          let params = {
              id: this.id,
              img_reback: this.photo_hkpz
          }
          if(this.photo_hkpz =='' || this.photo_hkpz == null){
						this.$toast.center(this.$t('hkxq.qschkpz'));
						return;
					}
          this.$ajax.get('/web/lendBack',{params}).then((res) => {
              let resData = res.data;
              if(resData.code == 5){
                this.isMask = true;
              }else if(resData.code == 0){
                this.$toast.center(this.$t('status.statusText')[2]);
                setTimeout(()=>{
                  this.isMask = false;
                  this.$router.push('/currencyRecord')
                },1500)
              }else if(res.data.code == 1000){
                  // this.$toast.center(res.data.message);
                  setTimeout(()=>{
                    this.$router.push('/index');
                  },1000)
                  return false
              }else{
                that.isMask = false;
              }
          }).catch(function(err){
              console.log(err)
          })
				},
        upload(){
          this.uploadimg(function (res) {

          })
        },
      uploadimg(callback){
			    let that = this;
			    that.ele_input(function(res) {
            if (res.length > 0) {
              var formdata = new FormData();
              for (var i = 0, len = res.length; i < len; i++) {
                lrz(res[0]).then(function (rst) {
                  var formdata = new FormData();
                  let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
                  formdata.append('file', file);
                  formdata.append('token', that.token);
                  formdata.append('app', 'h5');
                  that.isLoad = true;
                  $.ajax({
                    url: that.domain + "/web/uploadImg",
                    type: "POST",
                    data: formdata,
                    cache: false,
                    processData: false,
                    contentType: false,
                    success: function(data) {
                      if (typeof data == 'string') data = JSON.parse(data.data)
                      if (data && data.code == 0) {
                        that.isLoad = false;
                        that.photo_hkpz = data.data.url;
                      }else{
                        that.isLoad = false;
                        that.$toast.center(data.message);
                        return;
                      }
                    },error: function(data) {
                      that.isLoad = false;
                      that.$toast.center(data.message);
                      return;
                    }
                  });
                })
              }
            }
			  })
		  },
      ele_input(callback){
        var inputs = document.querySelector('.___input')
        if (!!inputs) {
          inputs.onchange = null
          inputs.onclick = null
          inputs.remove(0)
          // inputs.removeChild && inputs.removeChild(0)
        }
        var input = document.createElement('input')
        input.className = '___input'
        input.type = 'file'
        input.style.display = 'none'
        input.onchange = function() {
          var arr = []
          for (var i = 0, len = this.files.length; i < len; i++) {
            arr.push(this.files[i])
          }
          callback(arr)
        }
        input.accept = 'image/*'
        input.click();
        document.body.appendChild(input);
      },
      hideLoad(){
          this.isLoad = false;
      },
      close(){
        this.isMask = false
      },
      copy(e){
          let address = this.address;
          this.$copyText(address, this.$t('chongbi.fzcg'));
          this.$toast.center(this.$t('chongbi.fzcg'));
      },
    },
    beforeDestroy(){

    },
    filters: {
      times(timestamp){
        var date = new Date((timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + " " + h + m + s;
      }
    }
}
</script>
<style scoped>
.position-box{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url('../assets/element-background.png') no-repeat center center;
  background-size: cover;
}
    .header{
        height: 48px;
        padding: 0 10px;
        color: #fff;
        font-size: 13px;
        justify-content: space-between;
        background: #354148;
    }
    .header .text{
        position: relative;
        padding-right: 14px;
    }
    .header .text::after{
        position: absolute;
        right: 0;
        top: 50%;
        content: '';
        width: 0;
        height: 0;
        margin-top: -2px;
        border-top: 6px solid #fff;
        border-right: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid transparent;
    }
    .header .text .lang-box{
        position: absolute;
        right: 0;
        top: 48px;
        width: 120px;
        background: #fff;
        border-radius: 8px;
        border: 1px solid #e7e7e7;
    }
    .header .text .lang-box .lang{
        color: #000;
        font-size: 12px;
        border-bottom: 1px solid #e7e7e7;
        text-align: center;
    }
    .header .text .lang-box .lang:last-child{
        border-bottom: none;
    }
    .bg{
        position: absolute;
        left: 0;
        top: 48px;
        bottom: 0;
        width: 100%;
        max-width: 800px;
        height: auto;
        left: 50%;
        padding: 0 0 20px;
        box-sizing: border-box;
        transform: translateX(-50%);
        overflow: scroll;
    }
    .item1-box{
        width: 100%;
        height: 180px;
        background: #25292d;
        border-radius: 0 0 30px 30px;
    }
    .order-box{
        margin: -150px 16px 0;
        padding: 20px 12px;
        border-radius: 8px;
        background: #131e30;
        text-align: center;
    }
    .order-box .order{
        color: #fff;
        font-size: 16px;
    }
    .order-box .ewm-box{
        width: 125px;
        height: 120px;
        margin: 20px auto;
        background: #fff;
    }
    .order-box  .btn{
        height: 34px;
        margin-top: 20px;
        padding: 0 10px;
        color: #5d96b2;
        font-size: 13px;
        line-height: 34px;
        border: 1px solid #5d96b2;
        border-radius: 20px;
        background: transparent;
        cursor: pointer;
        text-align: center;
    }
    .tips{
        padding: 20px 16px 10px;
        color: #000;
        font-size: 15px;
        color: #fff;
        background: #131e30;
    }
    .ul-box .li{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 16px;
        color: #fff;
        font-size: 13px;
        border-bottom: 1px solid #313a47;
        background: #131e30;
    }
    .ul-box .li .t2{
        color: #808080;
    }
    .upload-box{
        padding: 16px;
        background: #131e30;
    }
    .upload-box .img{
        width: 144px;
        height: 82px;
    }
    .upload-box .text{
        width: 144px;
        margin-top: 12px;
        color: #7c7c7c;
        font-size: 12px;
        text-align: center;
    }
    .submit-box{
        padding: 20px 16px;
        background: #131e30;
    }
    .submit{
        display: block;
        width: 100%;
    }
    .repayment-alert{
        position: fixed;
        left: 50%;
        top: 50%;
        z-index: 1000;
        width: auto;
        min-width: 300px;
        max-width: 800px;
        padding: 48px 26px 34px;
        background: #fff;
        border-radius: 9px;
        transform: translate(-50%,-50%);
    }
    .repayment-alert .title{
        color: #3F3F3F;
        font-size: 18px;
        text-align: center;
    }
    .repayment-alert .btn{
        display: block;
        width: 100%;
        height: 40px;
        margin: 50px 0 0;
        color: #fff;
        font-size: 16px;
        border-radius: 9px;
        line-height: 40px;
        background: #588bf8;
        text-align: center;
    }
    #code{
      word-wrap: break-word;
    }
</style>



// WEBPACK FOOTER //
// src/pages/repayment.vue